import { LocalStorageKey } from "@royalty/model";
import { CoreToolbox } from "src/app/core/utils/core-toolbox";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
	MatDialog
} from "@angular/material";
import { AppConstants } from "../core/utils/app.const";
import { Router } from "@angular/router";

@Injectable()
export class MobileBehaviourService {
	rememberDisconnect: boolean = false;
	constructor(
		private translate: TranslateService,
		private dialogService: MatDialog,
		private router: Router
	) {}

	enableMobileBehaviour() {
		this.handleMobileEvent();
		this.handleNetworkChangeState();
		this.overrideBackButton();
	}

	private handleMobileEvent() {
		CoreToolbox.mobileService.appState$.subscribe(appState => {
			if (true === appState.isActive) {
				// Reload language
				CoreToolbox.storageService.initialize().finally(() => {
					this.translate.use(
						CoreToolbox.storageService.getItem(
							LocalStorageKey.language
						)
					);
				});

				// Check need to reload after resume app.
				this.checkAfterAppResume();
			}

			if (false === appState.isActive) {
				CoreToolbox.storageService.setItem(
					LocalStorageKey.TIME_APP_MINIMIZE,
					JSON.stringify(new Date().getTime())
				);
			}
		});
	}

	/**
	 * Check after app resume
	 */
	private checkAfterAppResume() {
		const timeBefore = CoreToolbox.storageService.getItem(
			LocalStorageKey.TIME_APP_MINIMIZE
		);
		if (
			timeBefore &&
			// tslint:disable-next-line: radix
			new Date().getTime() - parseInt(timeBefore) >
				AppConstants.TIME_NEED_TO_RELOAD
		) {
			this.navigateToHome();
		}
	}

	/**
	 * Handle override back button
	 */
	private overrideBackButton() {
		CoreToolbox.mobileService.overrideBackbutton().subscribe(() => {
			const overlayInst = document.getElementsByClassName(
				"cdk-overlay-container"
			);
			// Check and close all overlay
			if (overlayInst.length > 0 && overlayInst[0].hasChildNodes()) {
				this.dialogService.closeAll();
			} else {
				window.history.back();
			}
		});
	}

	/**
	 * Handle network change state.
	 */
	private handleNetworkChangeState() {
		CoreToolbox.networkService.networkChangeState$.subscribe(state => {
			if (state && this.rememberDisconnect) {
				this.rememberDisconnect = false;
				this.navigateToHome();
			} else {
				this.rememberDisconnect = true;
			}
		});
	}

	/**
	 * Navigate to home.
	 */
	private navigateToHome() {
		this.router.navigateByUrl("").finally(() => {
			location.reload();
		});
	}
}
